import { GanttZoomLevel } from './gantt-types';
import { addDays, createUtcDate, toStartOfUtcDay } from './gantt-date-core';

const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] as const;

export function formatAxisDate(date: Date, level: GanttZoomLevel): string {
  const month = MONTH_LABELS[toStartOfUtcDay(date).getUTCMonth()];
  const day = toStartOfUtcDay(date).getUTCDate();
  const year = toStartOfUtcDay(date).getUTCFullYear();

  if (level === GanttZoomLevel.Day) {
    return String(day);
  }

  if (level === GanttZoomLevel.Week) {
    return `${month} ${day}`;
  }

  const yearShort = String(year).slice(-2);
  return `${month} '${yearShort}`;
}

export function formatDateLabel(date: Date): string {
  const normalized = toStartOfUtcDay(date);
  const month = MONTH_LABELS[normalized.getUTCMonth()];
  const day = normalized.getUTCDate();
  return `${month} ${day}`;
}

export function getMonday(date: Date): Date {
  const normalized = toStartOfUtcDay(date);
  const dayOfWeek = normalized.getUTCDay();
  const offset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
  return addDays(normalized, offset);
}

export function getFirstOfMonth(date: Date): Date {
  const normalized = toStartOfUtcDay(date);
  return createUtcDate({
    year: normalized.getUTCFullYear(),
    month: normalized.getUTCMonth() + 1,
    day: 1,
  });
}
